export default __webpack_public_path__ + "MentiaLogoShort2024.png";